<template>
  <v-dialog
    v-model="dialog"
    max-width="700px">
    <v-card>
      <v-card-text>
        <v-row align="center" justify="center" class="mb-3 pt-3">
          <div class="input-file-block" v-ripple="{ class: 'white--text' }">
            <v-btn large color="primary">
              <v-icon left dark>movie</v-icon>
              Select a Video
            </v-btn>
            <input
              type="file"
              ref="file"
              @change="uploadFile"
            />
          </div>
          <span class="mr-2 text-uppercase ml-5">or</span>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="videos"
            :search="search"
            v-model="selected"
            item-key="id"
            select-all
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.title }}</td>
              <td class="text-xs-right">-</td>
              <td class="text-xs-right">{{ props.item.length | formatTime }}</td>
              <td class="text-xs-right">{{ props.item.updated_time | formatDate }}</td>
              <td class="text-xs-right">{{ getResolution(props.item.format) }}</td>
            </template>
          </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="closeWindowWithoutReloading"
        >
          Close
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="closeWindow"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'dialog-select-video',
    data () {
      return {
        search: '',
        selected: [],
        headers: [
          {
            text: 'Video name',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Type', value: 'type' },
          { text: 'Duration', value: 'duration' },
          { text: 'Date added', value: 'used' },
          { text: 'Resolution', value: 'resulution' }
        ]
      }
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      videos () {
        return this.$store.getters.getVideos
      }
    },
    filters: {
      formatDate (date) {
        return moment(date).format('MMM DD')
      },
      formatTime (time) {
        const minutes = Math.floor(time / 60)
        return `${minutes}:${Math.floor(time - minutes * 60)}`
      }
    },
    methods: {
      deleteVideo (id) {
        console.log(id)
      },
      uploadFile () {
        const file = this.$refs.file.files[0]
        let allowFileTypes = ['video/mp4', 'video/mov', 'image/gif', 'video/gif']
        if (!allowFileTypes.find(type => type === file.type)) {
          this.$store.dispatch('showNotification', {
            type: 'warning',
            message: ['<div>Next file types allowed: gif, png, jpg, jpeg</div>']
          })
          return false
        }
        this.$store.dispatch('uploadVideo', file)
      },
      getResolution (arr) {
        if (!arr || !arr.length) return 'Not found'
        const maxResolution = arr[arr.length - 1]
        return `${maxResolution.width} x ${maxResolution.height}`
      },
      closeWindow () {
        this.$emit('closeDialog', this.selected[0], true)
      },
      closeWindowWithoutReloading () {
        this.$emit('closeDialog', this.selected[0], false)
      }
    }
  }
</script>
